import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBack: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="back"><path d="M18.8437 4.11957C19.0745 3.97087 19.368 3.96011 19.609 4.09151C19.85 4.22292 20 4.47549 20 4.75V19.25C20 19.5245 19.85 19.7771 19.609 19.9085C19.368 20.0399 19.0745 20.0291 18.8437 19.8804L7.59372 12.6304C7.37946 12.4923 7.25 12.2549 7.25 12C7.25 11.7451 7.37946 11.5077 7.59372 11.3696L18.8437 4.11957Z" fill="currentColor"/><path d="M4 4.75C4 4.33579 4.33579 4 4.75 4C5.16421 4 5.5 4.33579 5.5 4.75V19.25C5.5 19.6642 5.16421 20 4.75 20C4.33579 20 4 19.6642 4 19.25V4.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBack;
